export default __webpack_public_path__ + "static/media/trustpilot-dark.223eec5d.svg";